import React from "react";
import { useHistory } from "react-router-dom";

import SearchBar from '../../components/SearchBar/SearchBar';

import "./Home.css";
import "../../pages/Search/Search.css";

export default function Home() {
  const history = useHistory();
  const navigateToSearchPage = (q) => {
    if (!q || q === '') {
      q = '*'
    }
    history.push('/search?q=' + q);
  }

  return (
    <main className="main main--home">
      <div className="row home-search">
        <img className="logo" src="/images/cognitive-search.png" alt="Cognitive Search"></img>
        
        <SearchBar postSearchHandler={navigateToSearchPage}></SearchBar>

        <b> Note: You need to sign in to get results</b>
      </div>
    </main>
  );
};
